"use client";
import { Stack } from "@mui/material";

import { useStore, observer } from "../../../../../service/mobx";
import FilterChips from "./Related/Filter";
import RelatedContent from "./Related/Content";

function SupportPaneRelated({ tab }) {
  const { device, reader } = useStore();

  return (device.isTablet && reader.whiteLabelled === false) ||
    device.isPhone ||
    reader.config?.disable?.has("related") ? null : (
    <Pane tab={tab} />
  );
}
export default observer(SupportPaneRelated);

export const Pane = observer(function Pane({ tab }) {
  const { reader } = useStore();

  return (
    <Stack
      spacing={3}
      pt={{
        compact: 0,
        expanded: 10,
        large: reader.whiteLabelled ? 10 : "152px"
      }}
      maxWidth={{ expanded: 360, large: "unset" }}
      sx={{
        "@media screen and (max-width: 950px)": {
          maxWidth: 300
        },
        "@media screen and (max-width: 850px)": {
          maxWidth: 200
        },
        "@media screen and (max-width: 640px)": {
          maxWidth: "100%"
        }
      }}
    >
      <FilterChips tab={tab} />
      <RelatedContent tab={tab} />
    </Stack>
  );
});
